import moment from 'moment-timezone'

class Rates {
  setFirebase (firebase) {
    this.firebase = firebase
    this.functions = this.firebase.functions()
    this.firestore = this.firebase.firestore()
    this.firestore.settings({ timestampsInSnapshots: true })
    this.getCharts = this.functions.httpsCallable('getCharts')
    this.rates = []
    this.nowPrice = 'loading...'
    this.nowTime = 'loading...'
    this.standardPrice = 'loading...'
    this.standardTime = 'loading...'
    this.nextTime = 'loading...'
    this.firestore.collection('btc_standard_rates').orderBy('createdAt', 'desc').limit(1).onSnapshot(snapshot => {
      this.updateStandardPrice()
    })
  }
  updateChart () {
    return this.getCharts().then(res => {
      this.rates = res.data.rates
      this.nowPrice = this.rates[this.rates.length - 1].rate
      this.nowTime = +moment.tz(this.rates[this.rates.length - 1].created_at, 'UTC') / 1000
      return this.rates
    })
  }
  updateStandardPrice () {
    return this.firestore.collection('btc_standard_rates').orderBy('createdAt', 'desc').limit(1).get().then(querySnapshot => {
      querySnapshot.forEach((doc) => {
        let data = doc.data()
        this.standardPrice = data.rate
        this.standardTime = data.createdAt.seconds
        this.nextTime = this.standardTime + 1800
      })
    })
  }
  getNowPrice () {
    return this.nowPrice
  }
  getNowTime () {
    return this.nowTime
  }
  getStandardPrice () {
    return this.standardPrice
  }
  getNextTime () {
    return this.nextTime
  }
  getStandardTime () {
    return this.standardTime
  }
  getRates () {
    return this.rates
  }
}
export default new Rates()



// WEBPACK FOOTER //
// ./src/class/Rates.js